import Tag from "./Tag";

export function SelectedItemsContainer({ nameToShow, items, onClick }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 10,
        marginBottom: 10,
      }}
    >
      {items.length > 0 && (
        <span style={{ fontWeight: "500", fontSize: 13 }}>
          {nameToShow} {items.length}
        </span>
      )}
      <div className="tag-content-sales-filter">
        {items.map((e, i) => {
          return <Tag text={e} key={i} tagId={i} onClick={onClick}></Tag>;
        })}
      </div>
    </div>
  );
}
